"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUpDownIcon = void 0;
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const ArrowUpDownIcon = (_a) => {
    var { fill = 'currentColor' } = _a, props = __rest(_a, ["fill"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { d: "M12.9631 10.8483L14.9052 8.90614C15.1356 8.67582 15.509 8.67582 15.7393 8.90614L17.6814 10.8483M15.3223 9.07889L15.3223 17.3359", stroke: fill, strokeWidth: "1.00195", strokeLinecap: "round" }), react_1.default.createElement("path", { d: "M12.5462 15.2211L10.6041 17.1632C10.3737 17.3935 10.0003 17.3935 9.76999 17.1632L7.82788 15.2211M10.187 16.9904L10.187 8.7334", stroke: fill, strokeWidth: "1.00195", strokeLinecap: "round" })));
};
exports.ArrowUpDownIcon = ArrowUpDownIcon;
exports.default = exports.ArrowUpDownIcon;
